import { checkGate, getLayer } from '@eventbrite/statsig';
import {
    APPLE_PAY_ON_LISTINGS_PAGE_EXPERIMENT,
    EXPRESS_PAYPAL_ON_TICKET_SELECTION_PAGE_EXPERIMENT,
    PlaceOrderAndTosVariant,
    SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT,
    SCROLLABLE_PLACE_ORDER_AND_TOS,
    URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT,
} from '../constants/statsig';

export const checkDisplayDonationCardFeatureGate = () =>
    checkGate('checkout_display_donation_card');

export const isUrgencySignalsExperimentEnabled = () => {
    const value = getLayer(
        URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT.layer,
        URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param,
        URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
    );

    return value === true || value === 'true';
};

export const isScrollableCtaExperimentEnabled = () => {
    const value = getLayer(
        SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT.layer,
        SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param,
        SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
    );
    return value === true || value === 'true';
};

export const isApplePayOnListingsExperimentEnabled = () => {
    const value = getLayer(
        APPLE_PAY_ON_LISTINGS_PAGE_EXPERIMENT.layer,
        APPLE_PAY_ON_LISTINGS_PAGE_EXPERIMENT.param,
        APPLE_PAY_ON_LISTINGS_PAGE_EXPERIMENT.defaultValue,
    );
    return value === true || value === 'true';
};

export const isExpressPaypalExperimentEnabled = () => {
    const value = getLayer(
        EXPRESS_PAYPAL_ON_TICKET_SELECTION_PAGE_EXPERIMENT.layer,
        EXPRESS_PAYPAL_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param,
        EXPRESS_PAYPAL_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
    );
    return value === true || value === 'true';
};

export const isScrollablePlaceOrderAndTosExperimentEnabled = () => {
    const { layer, param, defaultValue } = SCROLLABLE_PLACE_ORDER_AND_TOS;
    return getLayer<PlaceOrderAndTosVariant, PlaceOrderAndTosVariant>(
        layer,
        param,
        defaultValue,
    );
};
